package com.parmartechnologies.core.feature.inventory.size.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RetrieveSizeRequest(
    @SerialName("MasterBusinessID") val MasterBusinessID: String,
)

@Serializable
data class CreateSizeRequest(
    @SerialName("name") val name: String,
    @SerialName("value") val value: String,
    @SerialName("description") val description: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("user_id") val UserID: String,
)

@Serializable
data class UpdateSizeRequest(
    @SerialName("name") val name: String,
    @SerialName("_id") val id: String,
    @SerialName("value") val value: String,
    @SerialName("description") val description: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("user_id") val UserID: String,
)